var render = function render(){var _vm=this,_c=_vm._self._c;return _c('vue-final-modal',_vm._g(_vm._b({attrs:{"name":_vm.name,"classes":['vfm-container vfm-modal-content']},scopedSlots:_vm._u([{key:"default",fn:function({close}){return [(!_vm.noNav)?_c('modal-header',{on:{"close":close}},[_vm._v(_vm._s(_vm.title))]):_vm._e(),_vm._t("default")]}}],null,true)},'vue-final-modal',_vm.$attrs,false),_vm.$listeners))
}
var staticRenderFns = []

export { render, staticRenderFns }